module.exports = __webpack_public_path__ + "img/gd.1b330771.png";